import { useHead } from '@unhead/react'

interface SeoProps {
  title: string
  description: string
  path: string
  schema?: object | object[]
}

function Seo({ title, description, path, schema }: SeoProps) {
  const url = `https://www.mintcalculator.com${path}`
  const scripts = schema
    ? (Array.isArray(schema) ? schema : [schema]).map(s => ({
        type: 'application/ld+json',
        innerHTML: JSON.stringify(s),
      }))
    : []

  useHead({
    title: `${title} | Mint Calculator`,
    meta: [
      { name: 'description', content: description },
      { property: 'og:title', content: `${title} | Mint Calculator` },
      { property: 'og:description', content: description },
      { property: 'og:type', content: 'website' },
      { property: 'og:url', content: url },
      { name: 'twitter:card', content: 'summary_large_image' },
      { name: 'twitter:title', content: `${title} | Mint Calculator` },
      { name: 'twitter:description', content: description },
    ],
    link: [
      { rel: 'canonical', href: url },
    ],
    script: scripts,
  })

  return null
}

export default Seo
